// Module
var code = "<custom-widget-runtime data-bind=\"attr: { params: config }, styled: styles\"></custom-widget-runtime>\r\n";
// Exports
export default code;